"use client";

import { c as _c } from "react/compiler-runtime";
import { Check, Loader2, Linkedin } from "lucide-react";
import Image from "next/image";
import { useState, useRef, useEffect } from "react";
import { sendEmail } from "@/actions/send-email";
import { playPowerUp, playKeyClick, prewarmAudio } from "@/utils/audio";
import DecryptText from "@/components/DecryptText";
import { useNeumorphicTheme } from "@/hooks/useNeumorphicTheme";
import { InteractiveHoverButton } from "@/components/ui/interactive-hover-button";
function StealthGliderIcon(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <polygon points="22 2 2 10 9.5 13 13 14.5 22 2" fill="currentColor" fillOpacity="0.2" />;
    t2 = <polyline points="22 2 9.5 13 8 21 13 14.5" />;
    t3 = <line x1="22" y1="2" x2="13" y2="14.5" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>{t1}{t2}{t3}</svg>;
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function BongoCat(t0) {
  const $ = _c(37);
  const {
    pawState
  } = t0;
  const isNeumorphic = useNeumorphicTheme();
  const isLeftTapped = pawState === "left";
  const isRightTapped = pawState === "right";
  const t1 = `absolute inset-0 transition-opacity duration-200 ${isNeumorphic ? "opacity-100" : "opacity-0"}`;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image fill={true} unoptimized={true} src="/bongo/parts/group-white.svg" alt="" className="absolute inset-0 w-full h-full object-contain pointer-events-none" />;
    t3 = <Image fill={true} unoptimized={true} src="/bongo/parts/cat-black.png" alt="" className="absolute inset-0 w-full h-full object-contain pointer-events-none" />;
    t4 = <Image fill={true} unoptimized={true} src="/bongo/parts/mouth-open-black.png" alt="" className="absolute inset-0 w-full h-full object-contain pointer-events-none" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
  }
  const t5 = `absolute inset-0 w-full h-full object-contain pointer-events-none transition-opacity duration-75 ${isLeftTapped ? "opacity-0" : "opacity-100"}`;
  let t6;
  if ($[3] !== t5) {
    t6 = <Image fill={true} unoptimized={true} src="/bongo/parts/paw-left-down-black.png" alt="" className={t5} />;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = `absolute inset-0 w-full h-full object-contain pointer-events-none transition-opacity duration-75 ${isLeftTapped ? "opacity-100" : "opacity-0"}`;
  let t8;
  if ($[5] !== t7) {
    t8 = <Image fill={true} unoptimized={true} src="/bongo/parts/paw-left-up-black.png" alt="" className={t7} />;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const t9 = `absolute inset-0 w-full h-full object-contain pointer-events-none transition-opacity duration-75 ${isRightTapped ? "opacity-0" : "opacity-100"}`;
  let t10;
  if ($[7] !== t9) {
    t10 = <Image fill={true} unoptimized={true} src="/bongo/parts/paw-right-up-black.png" alt="" className={t9} />;
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const t11 = `absolute inset-0 w-full h-full object-contain pointer-events-none transition-opacity duration-75 ${isRightTapped ? "opacity-100" : "opacity-0"}`;
  let t12;
  if ($[9] !== t11) {
    t12 = <Image fill={true} unoptimized={true} src="/bongo/parts/paw-right-down-black.png" alt="" className={t11} />;
    $[9] = t11;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== t1 || $[12] !== t10 || $[13] !== t12 || $[14] !== t6 || $[15] !== t8) {
    t13 = <div className={t1}>{t2}{t3}{t4}{t6}{t8}{t10}{t12}</div>;
    $[11] = t1;
    $[12] = t10;
    $[13] = t12;
    $[14] = t6;
    $[15] = t8;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  const t14 = `absolute inset-0 transition-opacity duration-200 ${!isNeumorphic ? "opacity-100" : "opacity-0"}`;
  let t15;
  let t16;
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Image fill={true} unoptimized={true} src="/bongo/parts/group.svg" alt="" className="absolute inset-0 w-full h-full object-contain pointer-events-none" />;
    t16 = <Image fill={true} unoptimized={true} src="/bongo/parts/cat-white.png" alt="" className="absolute inset-0 w-full h-full object-contain pointer-events-none" />;
    t17 = <Image fill={true} unoptimized={true} src="/bongo/parts/mouth-open-white.png" alt="" className="absolute inset-0 w-full h-full object-contain pointer-events-none" />;
    $[17] = t15;
    $[18] = t16;
    $[19] = t17;
  } else {
    t15 = $[17];
    t16 = $[18];
    t17 = $[19];
  }
  const t18 = `absolute inset-0 w-full h-full object-contain pointer-events-none transition-opacity duration-75 ${isLeftTapped ? "opacity-0" : "opacity-100"}`;
  let t19;
  if ($[20] !== t18) {
    t19 = <Image fill={true} unoptimized={true} src="/bongo/parts/paw-left-down-white.png" alt="" className={t18} />;
    $[20] = t18;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  const t20 = `absolute inset-0 w-full h-full object-contain pointer-events-none transition-opacity duration-75 ${isLeftTapped ? "opacity-100" : "opacity-0"}`;
  let t21;
  if ($[22] !== t20) {
    t21 = <Image fill={true} unoptimized={true} src="/bongo/parts/paw-left-up-white.png" alt="" className={t20} />;
    $[22] = t20;
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  const t22 = `absolute inset-0 w-full h-full object-contain pointer-events-none transition-opacity duration-75 ${isRightTapped ? "opacity-0" : "opacity-100"}`;
  let t23;
  if ($[24] !== t22) {
    t23 = <Image fill={true} unoptimized={true} src="/bongo/parts/paw-right-up-white.png" alt="" className={t22} />;
    $[24] = t22;
    $[25] = t23;
  } else {
    t23 = $[25];
  }
  const t24 = `absolute inset-0 w-full h-full object-contain pointer-events-none transition-opacity duration-75 ${isRightTapped ? "opacity-100" : "opacity-0"}`;
  let t25;
  if ($[26] !== t24) {
    t25 = <Image fill={true} unoptimized={true} src="/bongo/parts/paw-right-down-white.png" alt="" className={t24} />;
    $[26] = t24;
    $[27] = t25;
  } else {
    t25 = $[27];
  }
  let t26;
  if ($[28] !== t14 || $[29] !== t19 || $[30] !== t21 || $[31] !== t23 || $[32] !== t25) {
    t26 = <div className={t14}>{t15}{t16}{t17}{t19}{t21}{t23}{t25}</div>;
    $[28] = t14;
    $[29] = t19;
    $[30] = t21;
    $[31] = t23;
    $[32] = t25;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  if ($[34] !== t13 || $[35] !== t26) {
    t27 = <div className="absolute -top-[48px] sm:-top-[58px] right-2 sm:right-6 z-30 pointer-events-none select-none w-[130px] sm:w-[160px] aspect-[447/262] rotate-[-4.5deg] origin-bottom-right" aria-hidden="true"><div className="relative w-full h-full">{t13}{t26}</div></div>;
    $[34] = t13;
    $[35] = t26;
    $[36] = t27;
  } else {
    t27 = $[36];
  }
  return t27;
}
export default function Contact(t0) {
  const $ = _c(177);
  const {
    dict
  } = t0;
  const [status, setStatus] = useState("idle");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [errors, setErrors] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [touched, setTouched] = useState(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      name: "",
      email: "",
      message: ""
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [values, setValues] = useState(t3);
  const isNeumorphic = useNeumorphicTheme();
  const [isFlying, setIsFlying] = useState(false);
  const [emailCopied, setEmailCopied] = useState(false);
  const [pawState, setPawState] = useState("idle");
  const typingTimeoutRef = useRef(null);
  const lastKeyRef = useRef(null);
  const lastPawRef = useRef("left");
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  useEffect(_temp2, t4);
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => {
      if (["Shift", "Control", "Alt", "Meta", "CapsLock", "Tab", "Escape"].includes(e.key)) {
        return;
      }
      let nextPaw;
      if (e.key === lastKeyRef.current) {
        nextPaw = lastPawRef.current;
      } else {
        nextPaw = lastPawRef.current === "left" ? "right" : "left";
      }
      lastKeyRef.current = e.key;
      lastPawRef.current = nextPaw;
      playKeyClick(nextPaw);
      setPawState(nextPaw);
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
      typingTimeoutRef.current = setTimeout(() => {
        setPawState("idle");
      }, 125);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleFormKeyDown = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e_0 => {
      if (e_0) {
        e_0.preventDefault();
      }
      navigator.clipboard.writeText("samyb.samir@gmail.com");
      setEmailCopied(true);
      setTimeout(() => setEmailCopied(false), 2000);
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleCopyEmail = t6;
  const emailErrorText = dict?.errEmail || "VALID EMAIL IS REQUIRED.";
  const messageErrorText = dict?.errMessage || "MESSAGE IS REQUIRED.";
  const useSmallErrorFont = emailErrorText.length > 25 || messageErrorText.length > 25;
  const isSubmitting = useRef(false);
  let t7;
  if ($[6] !== values.name) {
    t7 = values.name.trim();
    $[6] = values.name;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const isNameFilled = t7.length > 0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t8;
  let t9;
  if ($[8] !== dict?.btnSend || $[9] !== dict?.btnSending || $[10] !== dict?.copied || $[11] !== dict?.copyEmail || $[12] !== dict?.description || $[13] !== dict?.emailAddress || $[14] !== dict?.emailLabel || $[15] !== dict?.emailPlaceholder || $[16] !== dict?.errEmail || $[17] !== dict?.errMessage || $[18] !== dict?.errSend || $[19] !== dict?.lets || $[20] !== dict?.messageLabel || $[21] !== dict?.messagePlaceholder || $[22] !== dict?.nameLabel || $[23] !== dict?.networks || $[24] !== dict?.newTab || $[25] !== dict?.success || $[26] !== dict?.talk || $[27] !== emailCopied || $[28] !== errors.email || $[29] !== errors.message || $[30] !== isFlying || $[31] !== isNameFilled || $[32] !== isNeumorphic || $[33] !== pawState || $[34] !== status || $[35] !== touched || $[36] !== useSmallErrorFont || $[37] !== values.email || $[38] !== values.message || $[39] !== values.name) {
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email);
    let t19;
    if ($[51] !== values.message) {
      t19 = values.message.trim();
      $[51] = values.message;
      $[52] = t19;
    } else {
      t19 = $[52];
    }
    const isMessageValid = t19.length >= 13;
    const showEmailError = !!errors.email;
    const showMessageError = !!errors.message;
    let t20;
    if ($[53] !== dict?.errEmail || $[54] !== dict?.errMessage || $[55] !== touched) {
      t20 = e_1 => {
        const {
          name,
          value
        } = e_1.target;
        setValues(prev => ({
          ...prev,
          [name]: value
        }));
        if (touched[name as keyof typeof touched]) {
          let isValid = false;
          if (name === "email") {
            isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
          }
          if (name === "message") {
            isValid = value.trim().length >= 13;
          }
          setErrors(prev_0 => ({
            ...prev_0,
            [name]: isValid ? undefined : name === "email" ? dict?.errEmail || "VALID EMAIL IS REQUIRED." : dict?.errMessage || "MESSAGE IS REQUIRED."
          }));
        }
      };
      $[53] = dict?.errEmail;
      $[54] = dict?.errMessage;
      $[55] = touched;
      $[56] = t20;
    } else {
      t20 = $[56];
    }
    const handleChange = t20;
    let t21;
    if ($[57] !== dict?.errEmail || $[58] !== dict?.errMessage) {
      t21 = e_2 => {
        const {
          name: name_0,
          value: value_0
        } = e_2.target;
        if (name_0 !== "email" && name_0 !== "message") {
          return;
        }
        setTouched(prev_1 => ({
          ...prev_1,
          [name_0]: true
        }));
        let isValid_0 = false;
        if (name_0 === "email") {
          isValid_0 = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value_0);
        }
        if (name_0 === "message") {
          isValid_0 = value_0.trim().length >= 13;
        }
        setErrors(prev_2 => ({
          ...prev_2,
          [name_0]: isValid_0 ? undefined : name_0 === "email" ? dict?.errEmail || "VALID EMAIL IS REQUIRED." : dict?.errMessage || "MESSAGE IS REQUIRED."
        }));
      };
      $[57] = dict?.errEmail;
      $[58] = dict?.errMessage;
      $[59] = t21;
    } else {
      t21 = $[59];
    }
    const handleBlur = t21;
    const handleSubmit = async function handleSubmit(e_3) {
      e_3.preventDefault();
      if (isSubmitting.current) {
        return;
      }
      isSubmitting.current = true;
      const formData = new FormData(e_3.currentTarget);
      const newErrors = {};
      if (!isEmailValid) {
        newErrors.email = dict?.errEmail || "VALID EMAIL IS REQUIRED.";
      }
      if (!isMessageValid) {
        newErrors.message = dict?.errMessage || "MESSAGE IS REQUIRED.";
      }
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setTouched({
          email: true,
          message: true
        });
        isSubmitting.current = false;
        return;
      }
      setErrors({});
      setIsFlying(true);
      await new Promise(_temp3);
      setStatus("loading");
      const result = await sendEmail(formData);
      if (result?.error) {
        setStatus("error");
        isSubmitting.current = false;
        setIsFlying(false);
      } else {
        setStatus("success");
        setIsFlying(false);
      }
    };
    const getInputStyle = _temp4;
    t17 = "contact";
    t18 = "min-h-[80vh] flex flex-col justify-center pt-24 pb-16 px-6 md:px-12 lg:px-24 bg-black text-white overflow-hidden";
    t15 = "w-full max-w-[75rem] mx-auto flex flex-col lg:flex-row gap-8 lg:gap-12 items-center lg:items-stretch";
    const t22 = dict?.lets || "Let's";
    let t23;
    if ($[60] !== t22) {
      t23 = <DecryptText text={t22} />;
      $[60] = t22;
      $[61] = t23;
    } else {
      t23 = $[61];
    }
    let t24;
    if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <br />;
      $[62] = t24;
    } else {
      t24 = $[62];
    }
    const t25 = dict?.talk || "Talk";
    let t26;
    if ($[63] !== t25) {
      t26 = <DecryptText text={t25} />;
      $[63] = t25;
      $[64] = t26;
    } else {
      t26 = $[64];
    }
    let t27;
    if ($[65] !== t23 || $[66] !== t26) {
      t27 = <h2 className="text-6xl md:text-8xl font-black uppercase tracking-tighter leading-none">{t23}{t24}{t26}</h2>;
      $[65] = t23;
      $[66] = t26;
      $[67] = t27;
    } else {
      t27 = $[67];
    }
    let t28;
    if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = <div className="h-1.5 md:h-2 bg-current w-12 sm:w-20 md:w-28 shrink-0 self-center" />;
      $[68] = t28;
    } else {
      t28 = $[68];
    }
    let t29;
    if ($[69] !== t27) {
      t29 = <div className="flex items-center gap-4 sm:gap-6 mb-8 relative z-30">{t27}{t28}</div>;
      $[69] = t27;
      $[70] = t29;
    } else {
      t29 = $[70];
    }
    const t30 = dict?.description || "Drop a message to discuss a project, a full-time role, or just to say hi.";
    let t31;
    if ($[71] !== t30) {
      t31 = <p className="text-2xl font-bold max-w-md text-zinc-400 uppercase mb-8 lg:mb-12 relative z-30">{t30}</p>;
      $[71] = t30;
      $[72] = t31;
    } else {
      t31 = $[72];
    }
    let t32;
    if ($[73] !== t29 || $[74] !== t31) {
      t32 = <div>{t29}{t31}</div>;
      $[73] = t29;
      $[74] = t31;
      $[75] = t32;
    } else {
      t32 = $[75];
    }
    const t33 = dict?.emailAddress || "Direct Email:";
    let t34;
    if ($[76] !== t33) {
      t34 = <span className="text-[10px] font-black uppercase tracking-wider text-zinc-500 select-none">{t33}</span>;
      $[76] = t33;
      $[77] = t34;
    } else {
      t34 = $[77];
    }
    let t35;
    if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
      t35 = <span className="text-xs font-mono font-black break-all select-all border border-zinc-200 p-2 bg-zinc-50">samyb.samir [at] gmail [dot] com</span>;
      $[78] = t35;
    } else {
      t35 = $[78];
    }
    let t36;
    if ($[79] !== t34) {
      t36 = <div className="flex flex-col gap-1">{t34}{t35}</div>;
      $[79] = t34;
      $[80] = t36;
    } else {
      t36 = $[80];
    }
    let t37;
    if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
      t37 = <style>{"\n                  @keyframes contact-crumble-and-vanish {\n                    0% {\n                      transform: translateY(4px) scale(1) skewX(0deg) skewY(0deg);\n                      transform-origin: 12px 7px;\n                      clip-path: polygon(0% 0%, 50% 0%, 100% 0%, 100% 50%, 100% 100%, 50% 100%, 0% 100%, 0% 50%);\n                      opacity: 0;\n                    }\n                    18% {\n                      transform: translateY(-2px) scale(1) skewX(0deg) skewY(0deg);\n                      transform-origin: 12px 7px;\n                      clip-path: polygon(0% 0%, 50% 0%, 100% 0%, 100% 50%, 100% 100%, 50% 100%, 0% 100%, 0% 50%);\n                      opacity: 1;\n                    }\n                    36% {\n                      transform: translateY(-16px) scale(1) skewX(0deg) skewY(0deg);\n                      transform-origin: 12px 7px;\n                      clip-path: polygon(0% 0%, 50% 0%, 100% 0%, 100% 50%, 100% 100%, 50% 100%, 0% 100%, 0% 50%);\n                      opacity: 1;\n                    }\n                    50% {\n                      transform: translateY(-16px) scale(1) skewX(0deg) skewY(0deg);\n                      transform-origin: 12px 7px;\n                      clip-path: polygon(0% 0%, 50% 0%, 100% 0%, 100% 50%, 100% 100%, 50% 100%, 0% 100%, 0% 50%);\n                      opacity: 1;\n                    }\n                    62% {\n                      transform: translateY(-16px) scaleX(0.7) scaleY(0.85) skewX(15deg) skewY(-5deg);\n                      transform-origin: 12px 7px;\n                      clip-path: polygon(5% 8%, 52% 3%, 92% 6%, 96% 48%, 94% 92%, 48% 95%, 6% 91%, 3% 52%);\n                      opacity: 1;\n                    }\n                    74% {\n                      transform: translateY(-16px) scaleX(0.4) scaleY(0.55) skewX(-20deg) skewY(15deg);\n                      transform-origin: 12px 7px;\n                      clip-path: polygon(15% 20%, 48% 10%, 82% 16%, 88% 52%, 80% 82%, 52% 88%, 18% 80%, 12% 46%);\n                      opacity: 0.9;\n                    }\n                    86% {\n                      transform: translateY(-16px) scaleX(0.2) scaleY(0.2) skewX(25deg) skewY(-20deg);\n                      transform-origin: 12px 7px;\n                      clip-path: polygon(30% 32%, 50% 25%, 72% 28%, 76% 52%, 68% 70%, 48% 75%, 28% 68%, 24% 48%);\n                      opacity: 0.5;\n                    }\n                    95%, 100% {\n                      transform: translateY(-16px) scale(0);\n                      transform-origin: 12px 7px;\n                      clip-path: polygon(45% 46%, 50% 42%, 55% 46%, 56% 50%, 54% 54%, 50% 56%, 46% 54%, 45% 50%);\n                      opacity: 0;\n                    }\n                  }\n                  .contact-letter-crumble {\n                    animation: contact-crumble-and-vanish 1.7s cubic-bezier(0.25, 1, 0.5, 1) forwards;\n                  }\n                "}</style>;
      $[81] = t37;
    } else {
      t37 = $[81];
    }
    const t38 = `transition-all duration-300 ease-in-out ${emailCopied ? "opacity-100" : "opacity-0 group-hover/copycard:opacity-100"}`;
    let t39;
    if ($[82] !== t38) {
      t39 = <path d="M3 8l9-6 9 6" stroke="black" strokeWidth="2" fill="white" className={t38} />;
      $[82] = t38;
      $[83] = t39;
    } else {
      t39 = $[83];
    }
    let t40;
    if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
      t40 = <rect x="3" y="8" width="18" height="12" stroke="black" strokeWidth="2" fill="white" />;
      $[84] = t40;
    } else {
      t40 = $[84];
    }
    const t41 = emailCopied ? "contact-letter-crumble" : "";
    let t42;
    if ($[85] !== emailCopied) {
      t42 = !emailCopied ? {
        transform: "translateY(4px)",
        opacity: 0
      } : undefined;
      $[85] = emailCopied;
      $[86] = t42;
    } else {
      t42 = $[86];
    }
    let t43;
    let t44;
    if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
      t43 = <rect x="6" y="2" width="12" height="10" stroke="black" strokeWidth="2" fill="white" />;
      t44 = <path d="M10 7 l2 2 l3 -3" stroke="black" strokeWidth="2" strokeLinecap="square" />;
      $[87] = t43;
      $[88] = t44;
    } else {
      t43 = $[87];
      t44 = $[88];
    }
    const t45 = emailCopied ? 0.75 : 0;
    const t46 = emailCopied ? "opacity 0.2s ease 0.5s" : "opacity 0.1s ease";
    let t47;
    if ($[89] !== t45 || $[90] !== t46) {
      t47 = <path d="M8 3 l2 2 l-1 2 l3 -1 l-1 2" stroke="black" strokeWidth="1.2" className="transition-opacity duration-300" style={{
        opacity: t45,
        transition: t46
      }} />;
      $[89] = t45;
      $[90] = t46;
      $[91] = t47;
    } else {
      t47 = $[91];
    }
    const t48 = emailCopied ? 0.75 : 0;
    const t49 = emailCopied ? "opacity 0.2s ease 0.5s" : "opacity 0.1s ease";
    let t50;
    if ($[92] !== t48 || $[93] !== t49) {
      t50 = <path d="M16 4 l-3 2 l1 2 l-2 -1 l1 2" stroke="black" strokeWidth="1.2" className="transition-opacity duration-300" style={{
        opacity: t48,
        transition: t49
      }} />;
      $[92] = t48;
      $[93] = t49;
      $[94] = t50;
    } else {
      t50 = $[94];
    }
    let t51;
    if ($[95] !== t41 || $[96] !== t42 || $[97] !== t47 || $[98] !== t50) {
      t51 = <g className={t41} style={t42}>{t43}{t44}{t47}{t50}</g>;
      $[95] = t41;
      $[96] = t42;
      $[97] = t47;
      $[98] = t50;
      $[99] = t51;
    } else {
      t51 = $[99];
    }
    let t52;
    let t53;
    if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
      t52 = <path d="M3 8l9 6 9-6 v12 H3 z" stroke="black" strokeWidth="2" fill="white" />;
      t53 = <path d="M3 20l9-6 9 6" stroke="black" strokeWidth="2" />;
      $[100] = t52;
      $[101] = t53;
    } else {
      t52 = $[100];
      t53 = $[101];
    }
    const t54 = `transition-all duration-300 ease-in-out ${emailCopied ? "opacity-0" : "opacity-100 group-hover/copycard:opacity-0"}`;
    let t55;
    if ($[102] !== t54) {
      t55 = <path d="M3 8l9 6 9-6" stroke="black" strokeWidth="2" fill="white" className={t54} />;
      $[102] = t54;
      $[103] = t55;
    } else {
      t55 = $[103];
    }
    let t56;
    if ($[104] !== t39 || $[105] !== t51 || $[106] !== t55) {
      t56 = <div onClick={handleCopyEmail} className="cursor-pointer shrink-0 flex items-center justify-center p-2 active:scale-95 transition-transform touch-manipulation group/env" title="Copy Email">{t37}<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="black" strokeWidth="2" strokeLinecap="square" strokeLinejoin="miter" className="shrink-0 overflow-visible" aria-hidden="true">{t39}{t40}{t51}{t52}{t53}{t55}</svg></div>;
      $[104] = t39;
      $[105] = t51;
      $[106] = t55;
      $[107] = t56;
    } else {
      t56 = $[107];
    }
    const t57 = `col-start-1 row-start-1 transition-opacity duration-300 ${emailCopied ? "opacity-100" : "opacity-0 pointer-events-none"}`;
    const t58 = dict?.copied || "Copied!";
    let t59;
    if ($[108] !== t57 || $[109] !== t58) {
      t59 = <span className={t57}>{t58}</span>;
      $[108] = t57;
      $[109] = t58;
      $[110] = t59;
    } else {
      t59 = $[110];
    }
    const t60 = `col-start-1 row-start-1 transition-opacity duration-300 ${emailCopied ? "opacity-0 pointer-events-none" : "opacity-100"}`;
    const t61 = dict?.copyEmail || "Copy Email";
    let t62;
    if ($[111] !== t60 || $[112] !== t61) {
      t62 = <span className={t60}>{t61}</span>;
      $[111] = t60;
      $[112] = t61;
      $[113] = t62;
    } else {
      t62 = $[113];
    }
    let t63;
    if ($[114] !== t59 || $[115] !== t62) {
      t63 = <button type="button" onClick={handleCopyEmail} className="flex-1 py-3 px-3 border-2 border-black bg-black text-white hover:bg-white hover:text-black active:bg-white active:text-black font-mono font-black text-xs uppercase tracking-wider transition-colors text-center touch-manipulation select-none active:scale-95"><span className="relative grid grid-cols-1 grid-rows-1 justify-items-center">{t59}{t62}</span></button>;
      $[114] = t59;
      $[115] = t62;
      $[116] = t63;
    } else {
      t63 = $[116];
    }
    let t64;
    if ($[117] !== t56 || $[118] !== t63) {
      t64 = <div className="group/copycard w-full flex items-center justify-between gap-3 pt-1">{t56}{t63}</div>;
      $[117] = t56;
      $[118] = t63;
      $[119] = t64;
    } else {
      t64 = $[119];
    }
    let t65;
    if ($[120] !== t36 || $[121] !== t64) {
      t65 = <div className="lg:hidden bg-white text-black border-4 border-black p-4 mb-10 w-full max-w-md shadow-[6px_6px_0px_rgba(255,255,255,0.2)] flex flex-col gap-3 relative z-30 select-none">{t36}{t64}</div>;
      $[120] = t36;
      $[121] = t64;
      $[122] = t65;
    } else {
      t65 = $[122];
    }
    const t66 = dict?.networks || "Verified Networks";
    let t67;
    if ($[123] !== t66) {
      t67 = <h3 className="text-xl font-black uppercase tracking-widest text-zinc-400 mb-2 border-b-4 border-white pb-2 inline-block self-start">{t66}</h3>;
      $[123] = t66;
      $[124] = t67;
    } else {
      t67 = $[124];
    }
    let t68;
    if ($[125] === Symbol.for("react.memo_cache_sentinel")) {
      t68 = <Linkedin className="w-full h-full" fill="currentColor" />;
      $[125] = t68;
    } else {
      t68 = $[125];
    }
    const t69 = `LinkedIn${dict?.newTab || " (opens in a new tab)"}`;
    let t70;
    if ($[126] !== t69) {
      t70 = <InteractiveHoverButton href="https://linkedin.com/in/samybit/" target="_blank" rel="noopener noreferrer" icon={t68} aria-label={t69} className="!w-full sm:!w-48 text-base sm:text-xl p-2.5 sm:p-3 px-3 sm:px-6">LinkedIn</InteractiveHoverButton>;
      $[126] = t69;
      $[127] = t70;
    } else {
      t70 = $[127];
    }
    let t71;
    if ($[128] === Symbol.for("react.memo_cache_sentinel")) {
      t71 = <svg viewBox="0 0 16 16" fill="currentColor" className="w-full h-full scale-[1.15]"><path d="M4.654 3c.461 0 .887.035 1.278.14.39.07.711.216.996.391s.497.426.641.747c.14.32.216.711.216 1.137 0 .496-.106.922-.356 1.242-.215.32-.566.606-.997.817.606.176 1.067.496 1.348.922s.461.957.461 1.563c0 .496-.105.922-.285 1.278a2.3 2.3 0 0 1-.782.887c-.32.215-.711.39-1.137.496a5.3 5.3 0 0 1-1.278.176L0 12.803V3zm-.285 3.978c.39 0 .71-.105.957-.285.246-.18.355-.497.355-.887 0-.216-.035-.426-.105-.567a1 1 0 0 0-.32-.355 1.8 1.8 0 0 0-.461-.176c-.176-.035-.356-.035-.567-.035H2.17v2.31c0-.005 2.2-.005 2.2-.005zm.105 4.193c.215 0 .426-.035.606-.07.176-.035.356-.106.496-.216s.25-.215.356-.39c.07-.176.14-.391.14-.641 0-.496-.14-.852-.426-1.102-.285-.215-.676-.32-1.137-.32H2.17v2.734h2.305zm6.858-.035q.428.427 1.278.426c.39 0 .746-.106 1.032-.286q.426-.32.53-.64h1.74c-.286.851-.712 1.457-1.278 1.848-.566.355-1.243.566-2.06.566a4.1 4.1 0 0 1-1.527-.285 2.8 2.8 0 0 1-1.137-.782 2.85 2.85 0 0 1-.712-1.172c-.175-.461-.25-.957-.25-1.528 0-.531.07-1.032.25-1.493.18-.46.426-.852.747-1.207.32-.32.711-.606 1.137-.782a4 4 0 0 1 1.493-.285c.606 0 1.137.105 1.598.355.46.25.817.532 1.102.958.285.39.496.851.641 1.348.07.496.105.996.07 1.563h-5.15c0 .58.21 1.11.496 1.396m2.24-3.732c-.25-.25-.642-.391-1.103-.391-.32 0-.566.07-.781.176s-.356.25-.496.39a.96.96 0 0 0-.25.497c-.036.175-.07.32-.07.46h3.196c-.07-.526-.25-.882-.497-1.132zm-3.127-3.728h3.978v.957h-3.978z" /></svg>;
      $[128] = t71;
    } else {
      t71 = $[128];
    }
    const t72 = `Behance${dict?.newTab || " (opens in a new tab)"}`;
    let t73;
    if ($[129] !== t72) {
      t73 = <InteractiveHoverButton href="https://www.behance.net/samy-barsoum" target="_blank" rel="noopener noreferrer" icon={t71} aria-label={t72} className="!w-full sm:!w-48 text-base sm:text-xl p-2.5 sm:p-3 px-3 sm:px-6">Behance</InteractiveHoverButton>;
      $[129] = t72;
      $[130] = t73;
    } else {
      t73 = $[130];
    }
    let t74;
    if ($[131] === Symbol.for("react.memo_cache_sentinel")) {
      t74 = <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="0.6" strokeLinejoin="round" overflow="visible" className="w-full h-full scale-[1.15]"><path d="M18.561 13.158c-1.102 0-2.135-.467-3.074-1.227l.228-1.076.008-.042c.207-1.143.849-3.06 2.839-3.06 1.492 0 2.703 1.212 2.703 2.703-.001 1.489-1.212 2.702-2.704 2.702zm0-8.14c-2.539 0-4.51 1.649-5.31 4.366-1.22-1.834-2.148-4.036-2.687-5.892H7.828v7.112c-.002 1.406-1.141 2.546-2.547 2.548-1.405-.002-2.543-1.143-2.545-2.548V3.492H0v7.112c0 2.914 2.37 5.303 5.281 5.303 2.913 0 5.283-2.389 5.283-5.303v-1.19c.529 1.107 1.182 2.229 1.974 3.221l-1.673 7.873h2.797l1.213-5.71c1.063.679 2.285 1.109 3.686 1.109 3 0 5.439-2.452 5.439-5.45 0-3-2.439-5.439-5.439-5.439z" /></svg>;
      $[131] = t74;
    } else {
      t74 = $[131];
    }
    const t75 = `Upwork${dict?.newTab || " (opens in a new tab)"}`;
    let t76;
    if ($[132] !== t75) {
      t76 = <InteractiveHoverButton href="https://www.upwork.com/freelancers/~015e572ae8edee2be8" target="_blank" rel="noopener noreferrer" icon={t74} aria-label={t75} className="!w-full sm:!w-48 text-base sm:text-xl p-2.5 sm:p-3 px-3 sm:px-6">Upwork</InteractiveHoverButton>;
      $[132] = t75;
      $[133] = t76;
    } else {
      t76 = $[133];
    }
    let t77;
    if ($[134] === Symbol.for("react.memo_cache_sentinel")) {
      t77 = <svg viewBox="0 0 100 100" fill="currentColor" className="w-full h-full scale-[0.85]"><path d="M53.6232 47.1015H98.913C99.6377 47.1015 100 47.1014 100 46.3768V44.9275C100 44.5652 100 44.2029 99.2754 44.2029C77.8986 38.4058 61.2319 22.1014 55.7971 0.724637L54.3478 0H53.2609C52.8986 0 52.5362 0.36232 52.5362 1.08696V46.3768C52.5362 46.7391 52.5362 47.1015 53.2609 47.1015H53.6232ZM53.6232 100H55.0725L55.7971 99.2754C61.5942 77.8986 77.8986 61.2319 99.2754 55.7971L100 54.7101V53.6232C100 53.2609 99.6377 52.5362 98.913 52.5362H53.6232L52.8986 53.6232V98.913C52.8986 99.6377 52.8986 100 53.6232 100ZM45.2899 100H46.3768C46.7391 100 47.1015 99.6377 47.1015 98.913V53.6232C47.1015 53.2609 47.1015 52.5362 46.3768 52.5362H1.08696C0.362319 52.5362 0 53.2609 0 53.6232V55.0725C0 55.4348 0 55.7971 0.724638 55.7971C22.1015 61.2319 38.7681 77.8986 44.2029 99.2754L45.2899 100ZM1.08696 47.1015H46.3768C46.7391 47.1015 47.1015 47.1014 47.1015 46.3768V1.08696C47.1015 0.36232 47.1015 0 46.3768 0H44.9275C44.5652 0 44.2029 -7.01866e-07 44.2029 0.724637C38.4058 21.7391 21.7391 38.7681 0.724638 44.2029L0 45.2899V46.3768C0 46.7391 0.362319 47.1015 1.08696 47.1015Z" /></svg>;
      $[134] = t77;
    } else {
      t77 = $[134];
    }
    const t78 = `Contra${dict?.newTab || " (opens in a new tab)"}`;
    let t79;
    if ($[135] !== t78) {
      t79 = <InteractiveHoverButton href="https://contra.com/samy_barsoum_akavah3d" target="_blank" rel="noopener noreferrer" icon={t77} aria-label={t78} className="!w-full sm:!w-48 text-base sm:text-xl p-2.5 sm:p-3 px-3 sm:px-6">Contra</InteractiveHoverButton>;
      $[135] = t78;
      $[136] = t79;
    } else {
      t79 = $[136];
    }
    let t80;
    if ($[137] === Symbol.for("react.memo_cache_sentinel")) {
      t80 = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="7" className="w-full h-full scale-90"><circle cx="12" cy="12" r="7" /></svg>;
      $[137] = t80;
    } else {
      t80 = $[137];
    }
    const t81 = `mostaql${dict?.newTab || " (opens in a new tab)"}`;
    let t82;
    if ($[138] !== t81) {
      t82 = <InteractiveHoverButton href="https://mostaql.com/u/Samy_01" target="_blank" rel="noopener noreferrer" icon={t80} aria-label={t81} className="!w-full sm:!w-48 text-base sm:text-xl p-2.5 sm:p-3 px-3 sm:px-6">mostaql</InteractiveHoverButton>;
      $[138] = t81;
      $[139] = t82;
    } else {
      t82 = $[139];
    }
    let t83;
    if ($[140] === Symbol.for("react.memo_cache_sentinel")) {
      t83 = <svg viewBox="0 0 67.94 100" fill="currentColor" className="w-full h-full scale-[0.85]"><path d="M16 46.2269C17.6962 43.3192 19.7615 40.6423 22.1712 38.2327C25.0885 35.3154 28.3942 32.9038 32.0308 31.0404V16.0308H43.6712V0H16V46.2269ZM32.0308 37.1769C22.6077 43.05 16.2712 53.4077 16.0096 65.2673C16.0058 65.3942 16.0038 65.5212 16.0019 65.6481C16 65.775 16 65.9019 16 66.0288H32.0308C32.0308 58.3538 36.8788 51.7865 43.6712 49.2308V32.6462C39.4692 33.4365 35.5365 35.0058 32.0308 37.1942V37.1769ZM16.0404 83.9692H43.6712V100H16.0404V83.9692ZM49.9692 32.0615C49.65 32.0615 49.3327 32.0654 49.0154 32.0769V48.1173C49.3308 48.1 49.6481 48.0923 49.9692 48.0923C59.8596 48.0923 67.9077 56.1404 67.9077 66.0308C67.9077 75.9212 59.8596 83.9692 49.9692 83.9692H49.0154V100H49.9692C68.7 100 83.9385 84.7615 83.9385 66.0308C83.9385 47.3 68.7 32.0615 49.9692 32.0615ZM49.0154 0H79.1673V16.0308H49.0154V0Z" /></svg>;
      $[140] = t83;
    } else {
      t83 = $[140];
    }
    const t84 = `Khamsat${dict?.newTab || " (opens in a new tab)"}`;
    let t85;
    if ($[141] !== t84) {
      t85 = <InteractiveHoverButton href="https://khamsat.com/user/samy-b" target="_blank" rel="noopener noreferrer" icon={t83} aria-label={t84} className="!w-full sm:!w-48 text-base sm:text-xl p-2.5 sm:p-3 px-3 sm:px-6">Khamsat</InteractiveHoverButton>;
      $[141] = t84;
      $[142] = t85;
    } else {
      t85 = $[142];
    }
    let t86;
    if ($[143] !== t70 || $[144] !== t73 || $[145] !== t76 || $[146] !== t79 || $[147] !== t82 || $[148] !== t85) {
      t86 = <div className="grid grid-cols-2 sm:flex sm:flex-row sm:flex-wrap gap-2.5 sm:gap-4">{t70}{t73}{t76}{t79}{t82}{t85}</div>;
      $[143] = t70;
      $[144] = t73;
      $[145] = t76;
      $[146] = t79;
      $[147] = t82;
      $[148] = t85;
      $[149] = t86;
    } else {
      t86 = $[149];
    }
    let t87;
    if ($[150] !== t67 || $[151] !== t86) {
      t87 = <div className="flex flex-col gap-4 relative z-30">{t67}{t86}</div>;
      $[150] = t67;
      $[151] = t86;
      $[152] = t87;
    } else {
      t87 = $[152];
    }
    if ($[153] !== t32 || $[154] !== t65 || $[155] !== t87) {
      t16 = <div className="flex-1 w-full relative z-30 flex flex-col justify-between">{t32}{t65}{t87}</div>;
      $[153] = t32;
      $[154] = t65;
      $[155] = t87;
      $[156] = t16;
    } else {
      t16 = $[156];
    }
    t14 = "flex-1 w-full relative max-w-md mx-auto lg:mx-0";
    t8 = handleSubmit;
    t9 = true;
    t10 = handleFormKeyDown;
    t11 = "relative z-10 bg-white text-black border-4 border-black flex flex-col gap-2 md:gap-3 p-6 lg:p-8 shadow-[8px_8px_0px_rgba(255,255,255,0.3)] hover:translate-x-1 hover:translate-y-1 hover:shadow-none transition-all duration-300";
    if ($[157] !== pawState) {
      t12 = <BongoCat pawState={pawState} />;
      $[157] = pawState;
      $[158] = t12;
    } else {
      t12 = $[158];
    }
    t13 = status === "success" ? <div className="p-8 border-4 border-black bg-green-400 text-black text-2xl font-black uppercase text-center flex flex-col items-center gap-4 relative z-20"><Check size={48} className="text-black" />{dict?.success || "Message Received. I'll be in touch."}</div> : <><div className="flex flex-col gap-1.5 relative z-20 pb-5 md:pb-6"><label htmlFor="name" className="text-lg md:text-xl font-black uppercase tracking-wide flex items-center select-none">{dict?.nameLabel || "Name"}</label><input type="text" id="name" name="name" value={values.name} onChange={handleChange} onFocus={prewarmAudio} className={getInputStyle(isNameFilled, false)} placeholder="" aria-invalid="false" autoComplete="name" /></div><div className="flex flex-col gap-1.5 relative z-20 pb-5 md:pb-6"><label htmlFor="email" className="text-lg md:text-xl font-black uppercase tracking-wide flex items-center select-none">{dict?.emailLabel || "Email"}<span className="text-red-600 ms-1 font-black">*</span></label><input type="email" id="email" name="email" value={values.email} onChange={handleChange} onBlur={handleBlur} onFocus={prewarmAudio} className={`${getInputStyle(isEmailValid, showEmailError)} text-left`} placeholder={dict?.emailPlaceholder || "...@example.com"} aria-invalid={showEmailError ? "true" : "false"} aria-describedby={errors.email ? "email-error" : undefined} autoComplete="email" dir="ltr" /><span id="email-error" className={`absolute bottom-0 left-0 rtl:left-auto rtl:right-0 text-red-600 ${useSmallErrorFont ? "text-[clamp(9.2px,2.4vw,13px)]" : "text-[clamp(10px,3.2vw,14px)]"} md:text-base font-black uppercase tracking-wide whitespace-nowrap border-s-4 border-red-600 ps-2 transition-all duration-300 ease-out ${errors.email ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}`}>{errors.email}</span></div><div className="flex flex-col gap-1.5 relative z-20 pb-5 md:pb-6"><label htmlFor="message" className="text-lg md:text-xl font-black uppercase tracking-wide flex items-center select-none">{dict?.messageLabel || "Message"}<span className="text-red-600 ms-1 font-black">*</span></label><textarea id="message" name="message" rows={3} value={values.message} onChange={handleChange} onBlur={handleBlur} onFocus={prewarmAudio} className={getInputStyle(isMessageValid, showMessageError)} placeholder={dict?.messagePlaceholder || "Describe your project, an open role, or how we can collaborate..."} aria-invalid={showMessageError ? "true" : "false"} aria-describedby={errors.message ? "message-error" : undefined} /><span id="message-error" className={`absolute bottom-0 left-0 rtl:left-auto rtl:right-0 text-red-600 ${useSmallErrorFont ? "text-[clamp(9.2px,2.4vw,13px)]" : "text-[clamp(10px,3.2vw,14px)]"} md:text-base font-black uppercase tracking-wide whitespace-nowrap border-s-4 border-red-600 ps-2 transition-all duration-300 ease-out ${errors.message ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}`}>{errors.message}</span></div><button type="submit" onMouseEnter={prewarmAudio} onTouchStart={prewarmAudio} onClick={() => {
        if (status !== "loading" && !isSubmitting.current) {
          playPowerUp();
        }
      }} disabled={status === "loading"} className={`mt-2 flex items-center justify-center py-3 px-5 text-xl md:text-2xl font-black uppercase transition-all duration-300 ease-in-out group relative z-20 ${isNeumorphic ? "bg-[#e0e5ec] text-[#4b5563] rounded-2xl border border-transparent shadow-[6px_6px_12px_rgba(163,177,198,0.6),_-6px_-6px_12px_rgba(255,255,255,0.5)] hover:bg-[#d1d9e6] hover:text-[#1e293b] hover:shadow-[8px_8px_16px_rgba(163,177,198,0.7),_-8px_-8px_16px_rgba(255,255,255,0.6)] active:shadow-[inset_4px_4px_8px_rgba(163,177,198,0.6),_inset_-4px_-4px_8px_rgba(255,255,255,0.5)]" : `bg-black text-white border-4 border-black ${status === "loading" ? "opacity-80 cursor-wait translate-x-1 translate-y-1 shadow-[4px_4px_0px_#000]" : "shadow-[8px_8px_0px_#000] hover:bg-white hover:text-black hover:shadow-[4px_4px_0px_#000] hover:translate-x-1 hover:translate-y-1 active:shadow-none active:translate-x-2 active:translate-y-2"}`}`}><span className="transition-transform duration-300">{status === "loading" ? dict?.btnSending || "Sending..." : dict?.btnSend || "Send Message"}</span><div className={`flex items-center transition-all duration-300 ease-out ${status === "loading" || isFlying ? "w-6 md:w-8 ms-3 opacity-100 overflow-visible" : "w-0 opacity-0 overflow-hidden group-hover:w-6 group-active:w-6 md:group-hover:w-8 group-hover:ms-2 group-active:ms-2 md:group-hover:ms-3 group-hover:opacity-100 group-active:opacity-100"}`}>{status === "loading" ? <Loader2 className="w-5 h-5 md:w-6 md:h-6 shrink-0 animate-spin" /> : <StealthGliderIcon className={`w-5 h-5 md:w-6 md:h-6 shrink-0 ${isFlying ? "animate-fly-out" : "rtl:-scale-x-100 rtl:translate-x-full -translate-x-full rtl:group-hover:-translate-x-0 group-hover:translate-x-0 rtl:group-active:-translate-x-0 group-active:translate-x-0 transition-transform duration-300 ease-out"}`} />}</div></button>{status === "error" && <p className="text-red-600 font-black uppercase text-center mt-2 border-4 border-red-600 p-2 bg-red-100 relative z-20">{dict?.errSend || "FAILED TO SEND. PLEASE TRY AGAIN."}</p>}</>;
    $[8] = dict?.btnSend;
    $[9] = dict?.btnSending;
    $[10] = dict?.copied;
    $[11] = dict?.copyEmail;
    $[12] = dict?.description;
    $[13] = dict?.emailAddress;
    $[14] = dict?.emailLabel;
    $[15] = dict?.emailPlaceholder;
    $[16] = dict?.errEmail;
    $[17] = dict?.errMessage;
    $[18] = dict?.errSend;
    $[19] = dict?.lets;
    $[20] = dict?.messageLabel;
    $[21] = dict?.messagePlaceholder;
    $[22] = dict?.nameLabel;
    $[23] = dict?.networks;
    $[24] = dict?.newTab;
    $[25] = dict?.success;
    $[26] = dict?.talk;
    $[27] = emailCopied;
    $[28] = errors.email;
    $[29] = errors.message;
    $[30] = isFlying;
    $[31] = isNameFilled;
    $[32] = isNeumorphic;
    $[33] = pawState;
    $[34] = status;
    $[35] = touched;
    $[36] = useSmallErrorFont;
    $[37] = values.email;
    $[38] = values.message;
    $[39] = values.name;
    $[40] = t10;
    $[41] = t11;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
    $[46] = t16;
    $[47] = t17;
    $[48] = t18;
    $[49] = t8;
    $[50] = t9;
  } else {
    t10 = $[40];
    t11 = $[41];
    t12 = $[42];
    t13 = $[43];
    t14 = $[44];
    t15 = $[45];
    t16 = $[46];
    t17 = $[47];
    t18 = $[48];
    t8 = $[49];
    t9 = $[50];
  }
  let t19;
  if ($[159] !== t10 || $[160] !== t11 || $[161] !== t12 || $[162] !== t13 || $[163] !== t8 || $[164] !== t9) {
    t19 = <form onSubmit={t8} noValidate={t9} onKeyDown={t10} className={t11}>{t12}{t13}</form>;
    $[159] = t10;
    $[160] = t11;
    $[161] = t12;
    $[162] = t13;
    $[163] = t8;
    $[164] = t9;
    $[165] = t19;
  } else {
    t19 = $[165];
  }
  let t20;
  if ($[166] !== t14 || $[167] !== t19) {
    t20 = <div className={t14}>{t19}</div>;
    $[166] = t14;
    $[167] = t19;
    $[168] = t20;
  } else {
    t20 = $[168];
  }
  let t21;
  if ($[169] !== t15 || $[170] !== t16 || $[171] !== t20) {
    t21 = <div className={t15}>{t16}{t20}</div>;
    $[169] = t15;
    $[170] = t16;
    $[171] = t20;
    $[172] = t21;
  } else {
    t21 = $[172];
  }
  let t22;
  if ($[173] !== t17 || $[174] !== t18 || $[175] !== t21) {
    t22 = <section id={t17} className={t18}>{t21}</section>;
    $[173] = t17;
    $[174] = t18;
    $[175] = t21;
    $[176] = t22;
  } else {
    t22 = $[176];
  }
  return t22;
}
function _temp4(isValid_1, isError) {
  if (isError) {
    return "p-3 md:p-4 border-4 text-lg md:text-xl resize-none focus:outline-none transition-colors duration-150 relative z-20 border-red-600 bg-red-50 text-black";
  }
  if (isValid_1) {
    return "p-3 md:p-4 border-4 text-lg md:text-xl resize-none focus:outline-none transition-colors duration-150 relative z-20 border-green-600 bg-white text-black focus:ring-4 focus:ring-green-600/20";
  }
  return "p-3 md:p-4 border-4 text-lg md:text-xl resize-none focus:outline-none transition-colors duration-150 relative z-20 border-black bg-white text-black focus:ring-4 focus:ring-black/20";
}
function _temp3(resolve) {
  return setTimeout(resolve, 600);
}
function _temp2() {
  const parts = ["cat-black.png", "cat-white.png", "mouth-open-black.png", "mouth-open-white.png", "paw-left-down-black.png", "paw-left-down-white.png", "paw-left-up-black.png", "paw-left-up-white.png", "paw-right-down-black.png", "paw-right-down-white.png", "paw-right-up-black.png", "paw-right-up-white.png", "group.svg", "group-white.svg"];
  parts.forEach(_temp);
}
function _temp(file) {
  const img = new window.Image();
  img.src = `/bongo/parts/${file}`;
}